import { calculateDistance, circlePolyline } from '../../../libraries/geometric';

export const dragVertex = (state, e) => {
    const center = state.feature.properties.center;
    const movedVertex = [e.lngLat.lng, e.lngLat.lat];
    var radius = calculateDistance(movedVertex, center);
    var coordinates = circlePolyline(center, radius);
    state.feature.incomingCoords([coordinates]);
    state.feature.properties.radius = radius;
}

import createVertex from '../../../libraries/mapbox-gl-draw/src/lib/create_vertex';
export const createSupplementaryPoints = geojson => {
    const { properties, geometry } = geojson;
    if (!properties.user_isCircle) return null;

    const supplementaryPoints = [];
    const vertices = geometry.coordinates[0].slice(0, -1);
    for (let index = 0; index < vertices.length; index += Math.round((vertices.length / 4))) {
        supplementaryPoints.push(createVertex(properties.id, vertices[index], `0.${index}`, false));
    }
    return supplementaryPoints;
}

export const moveFeature = (feature, constrainedDelta) => {
    feature.properties.center[0] += constrainedDelta.lng;
    feature.properties.center[1] += constrainedDelta.lat;
    const coordinates = circlePolyline(feature.properties.center, feature.properties.radius);
    feature.incomingCoords([coordinates]);
};